import { Link, useHistory } from "react-router-dom";
import arrowIcon from "assests/img/right-arrow-icon.svg";
import backIcon from "assests/img/back-icon.svg";
import { CATEGORY_LIST, CREATE_PRODUCT, PRODUCT_CREATE, PRODUCT_DELTA_CATEGORY_LIST } from "../ProductConstants";
import CustomSearchBar from "../components/CustomSearchBar";

import { MouseEventHandler, useContext, useEffect, useState } from "react";
import { BulkAction } from "./BulkAction";
import ProductFilter from "./ProductFilter";
import ProductSort from "./ProductSort";
import { TAttribute, TProductDeltaHeaderProps } from "types/Pages/ProductDelta";
import { ProductsContext } from "../ProductsContext";
import CreateEditParentDialog from "./CreateEditParentDialog";
import MoveToParentDialog from "./MoveToParentDialog";
import ReactDOM from "react-dom"
import ServiceWrapper from "Services/ServiceWrapper";
import AuthManager from "Common/AuthManager";
import AppSettings from "Settings/AppSettings";
import { toast } from "react-toastify";
import ProductDeleteConfirmationModal from "../components/ProductDeleteConfirmModal";
import CreatePDW from "../PDW/CreatePDW";
import UpdatePDW from "../PDW/UpdatePDW";
import ValidatePDW from "../PDW/ValidatePDW";
import LogsPDW from "../PDW/LogsPDW";
import TemplatePDW from "../PDW/TemplatePDW";
import { AppContext } from "Context/AppContext";
import ProductCategoryDropDown from "./ProductCategoryDropDown";
import _ from "lodash";
import { createParent } from "api/Parent";
import BulkDeleteXLSModal from "../PDW/BulkDeleteXLS";
import DeleteParentModal from "./DeleteParentModal";
import RemoveChildModal from "./RemoveChildModal";
import { XIcon } from "assests/GmsIcons";
import React from "react";
import RecategorizeModal from "../Recategorization/components/RecategorizeModal";

const ProductDeltaHeader = ({
    handleSearchChange,
    categoryid,
    filters,
    setFilters,
    updateFilters,
    totalProducts,
    dataLoading,
    setDataLoading,
    productSelected,
    setProductSelected,
    childSelected,
    setChildSelected,
    moveToParentModal,
    setMoveToParentModal,
    createParentModal,
    setCreateParentModal,
    ...props
}: TProductDeltaHeaderProps) => {
    const history = useHistory();
    let appData = useContext(AppContext);
    let industryId = appData?.get_selected_industry()?.id ?? "";
    const channelKey = appData?.channelKey;
    const createPermission = appData.pm.checkPermission("gmsproducts_create");
    const prodContext = useContext<any>(ProductsContext)
    const selectedCategoryName = prodContext?.selected_Category?.name ?? '';
    const [search, setSearch] = useState<string>("")
    const [parentId, setParentId] = useState<string | null>(null)
    const [formLoading, setFormLoading] = useState<boolean>(false)
    const [deleteLoading, setDeleteLoading] = useState<boolean>(false)
    const [downloadUrl, setDownloadUrl] = useState("");

    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [bulkDeleteXLSModal, setBulkDeleteXLSModal] = useState<boolean>(false);

    const [categoriesList, setCategoriesList] = useState(null);
    const [categoryTypeList, setCategoryTypeList] = useState(null);

    const [showCreatePopup, setShowCreatePopup] = useState(false);
    const modalCreateOpen = () => setShowCreatePopup(true);
    const modalCreateClose = () => setShowCreatePopup(false);

    const [showUpdatePopup, setShowUpdatePopup] = useState(false);
    const modalUpdateOpen = () => setShowUpdatePopup(true);
    const modalUpdateClose = () => setShowUpdatePopup(false);

    const [showValidatePopup, setShowValidatePopup] = useState(false);
    const modalValidateOpen = () => setShowValidatePopup(true);
    const modalValidateClose = () => setShowValidatePopup(false);

    const [showRecategorizePopup, setShowRecategorizePopup] = useState(false);
    const modalRecategorizeOpen = () => setShowRecategorizePopup(true);
    const modalRecategorizeClose = () => {
        setDataLoading(true)
        setShowRecategorizePopup(false)
        setChildSelected([])
        setProductSelected([])
        setParentId(null)
        setTimeout(() => {
            props.fetchData()
            setDataLoading(false)
        }, 5000);
    };

    const [showLogs, setShowLogs] = useState(false);
    const modalLogsOpen = () => setShowLogs(true);
    const modalLogsClose = () => setShowLogs(false);
    const [showTemplate, setShowTemplate] = useState(false);
    const modalTemplateOpen = () => setShowTemplate(true);
    const openBulkDeleteXLSModal = () => setBulkDeleteXLSModal(true);
    const modalTemplateClose = () => setShowTemplate(false);
    const { fetchAttributes, selectedFilterList } = prodContext
    const api_base_url = AppSettings.GMS_BACKEND_API_URL

    const openDialog = () => {
        setCreateParentModal(false)
        setMoveToParentModal(true);
        setDeleteModal(false)
    };

    const openDeleteModal = () => {
        setCreateParentModal(false)
        setMoveToParentModal(false);
        setDeleteModal(true)
    };

    // const openRemoveChild = () => {
    //     setCreateParentModal(false)
    //     setMoveToParentModal(false);
    //     setDeleteModal(false)
    // };

    const openParentModal = () => {
        setCreateParentModal(true)
        setMoveToParentModal(false);
        setDeleteModal(false)
    };

    const closeParentModal = () => {
        setProductSelected([]);
        setCreateParentModal(false);
        setSearch("")
    };

    const closeDialog = () => {
        setProductSelected([]);
        setMoveToParentModal(false);
        setSearch("")
    };

    const closeDeleteModal = () => {
        setDeleteModal(false);
    };

    const handleAttributesChange = (attributes: string[]) => {
        if (!_.isEqual(filters.filters ?? [], attributes)) updateFilters({ filters: attributes, page: 0 })
    }

    useEffect(() => {
        if (industryId) fetchData();
    }, [industryId]);

    const getSelectedProductListForRecategorization = () => {
        return productSelected?.map(x => { return { id: x?.id, name: x?.name } })
    }

    const [selectedProducts, setSelectedProducts] = useState(getSelectedProductListForRecategorization())

    useEffect(() => {
        setSelectedProducts(getSelectedProductListForRecategorization())
    }, [productSelected])

    // if value is given it means its an array
    const handleFilterDelete = (e: React.MouseEvent, key: string, value?: string) => {
        if (!value) setFilters((prev) => {
            const next = { ...prev }
            delete next[key]
            if (key === "limit" && 'page' in next) delete next['page']
            return next
        })
        else setFilters((prev) => {
            const next = { ...prev }
            const index = next[key].indexOf(value)
            if (index > -1) next[key].splice(index, 1)
            return next
        })
    }

    const handleCreateParent = async (search: string, disabledAttributes: string[]) => {
        const res = await createParent(categoryid, search, [...productSelected.map((i) => i.id)], disabledAttributes)
        if (res[0]) {
            setChildSelected([])
            setProductSelected([])
            toast.success(res[1].message)
            closeParentModal()
            props.fetchData()
        }
    }

    const handleMovetoParent: MouseEventHandler<HTMLButtonElement> = async (e) => {
        if (!categoryid) return toast.error("Category not found")
        if (productSelected.length === 0 && childSelected.length === 0) return toast.error("Select at least one product")
        if (!parentId) return toast.error("Parent should be selected")
        setFormLoading(true)

        const res = await ServiceWrapper.doPut(
            api_base_url + "product/change_or_assign_parent",
            {
                new_parent: parentId,
                variants: [...productSelected.map((i) => i.id), ...childSelected.map((i) => i.id)]
            },
            null,
            AuthManager.getGmsToken()
        )

        if (!res.data.done)
            toast.error(res.data.message ?? "Failed to move products to parent")
        else {
            setChildSelected([])
            setProductSelected([])
            setParentId(null)
            toast.success(res.data.message)
            closeDialog()
            props.fetchData()
        }
        setFormLoading(false)
    }

    async function checkUploadStatus(jobId: string, check: boolean) {
        if (jobId) {
            const ret = await ServiceWrapper.doGet(
                api_base_url + "job/status/" + jobId,
                null,
                null,
                AuthManager.getGmsToken()
            );

            if (!ret.errorfound) {
                if (ret.data.processing) {
                    setDeleteLoading(true)
                    setTimeout(() => {
                        checkUploadStatus(jobId, check);
                    }, 2000);
                    return;
                }

                if (ret.data.error) {
                    toast.error(ret.data.status);
                    setDeleteLoading(false)
                    return;
                }
                setDeleteLoading(false)
                closeDeleteModal();
                setProductSelected([])
                setChildSelected([])
                toast.success(ret.data.status);
            }
        } else {
            toast.error("Job Id not found");
            setDeleteLoading(false)
        }
    }

    const handleDelete = async () => {
        setDeleteLoading(true);
        const res = await ServiceWrapper.doPost(
          api_base_url + "product/bulk_delete/channel/" + channelKey,
          { product_ids: [...productSelected.map((i) => i.id), ...childSelected.map((i) => i.id)] },
          null,
          AuthManager.getGmsToken()
        );
        setSearch("");
        if (!res.errorfound) {
          if (res.data.task_id) {
            checkUploadStatus(res.data.task_id, true);
          } else {
            props.fetchData();
            closeDeleteModal();
            setDeleteLoading(false);
            setProductSelected([]);
            setChildSelected([]);
      
            // Enhanced toast messages based on response data
            const { count, completely_deleted, channel_mapping_removed, failed, total_processed } = res.data;
      
            if (count > 0) {
              // Success message for deleted products
              let detailsMessage = "";
              if (completely_deleted > 0 && channel_mapping_removed > 0) {
                detailsMessage = `${completely_deleted} product${completely_deleted > 1 ? 's' : ''} completely deleted, ${channel_mapping_removed} product${channel_mapping_removed > 1 ? 's' : ''} removed from the environment`;
              } else if (completely_deleted > 0) {
                detailsMessage = `${completely_deleted} product${completely_deleted > 1 ? 's' : ''} completely deleted`;
              } else if (channel_mapping_removed > 0) {
                detailsMessage = `${channel_mapping_removed} product${channel_mapping_removed > 1 ? 's' : ''} removed from the environment`;
              } else {
                detailsMessage = `${count} product${count > 1 ? 's' : ''} deleted successfully`;
              }
              
              toast.success(
                <div>
                  Products deleted successfully.
                  <br />
                  <strong>Details:</strong> {detailsMessage}
                </div>
              );
            }
      
            // Warning/Error message for failed products
            if (failed > 0) {
              if (count > 0) {
                // Some succeeded, some failed
                toast.warning(
                  <div>
                    Unable to delete some products.
                    <br />
                    <strong>Reason:</strong> {failed} product{failed > 1 ? 's' : ''} failed to delete due to missing product to environment mapping
                  </div>
                );
              } else {
                // All failed
                toast.error(
                  <div>
                    Unable to delete products.
                    <br />
                    <strong>Reason:</strong> All products failed to delete due to missing product to environment mapping
                  </div>
                );
              }
            }
      
            // Info message if no products were processed
            if (total_processed === 0) {
              toast.error(
                <div>
                  Unable to delete products.
                  <br />
                  <strong>Reason:</strong> No products were selected for deletion
                </div>
              );
            }
          }
        } else {
          setDeleteLoading(false);
          toast.error(
            <div>
              Unable to delete products.
              <br />
              <strong>Reason:</strong> An error occurred while deleting products
            </div>
          );
        }
      };

    async function fetchData() {
        Promise.all([load_categories(), load_category_types()])
            .then((res) => {
            })
            .catch((err) => {
                console.log(err);
            });
    }

    async function load_categories(): Promise<any> {
        return ServiceWrapper.doGet(
            `${api_base_url}category/getbyindustryid/${industryId}`,
            null,
            null,
            AuthManager.getGmsToken()
        ).then(res => {
            if (res.errorfound) {
                toast.error("Error while Fetching categories details");
                return null;
            }
            if (!res.data.done) { toast.error(res.data.message); return null; }

            const categories = res.data.data.reduce((acc: any, category: any) => {
                (acc[category.cattype] = acc[category.cattype] || []).push(category);
                return acc;
            }, {});

            setCategoriesList(categories);
            return categories;
        });
    }

    async function load_category_types(): Promise<any> {
        return ServiceWrapper.doGet(
            `${api_base_url}categorytype/getbyindustryid/${industryId}`,
            null,
            null,
            AuthManager.getGmsToken()
        ).then(res => {
            if (res.errorfound) { toast.error("Error while Fetching categories details"); return null; }
            if (!res.data.done) { toast.error(res.data.message); return null; }

            setCategoryTypeList(res.data.data);
            return res.data.data;
        });
    }

    async function generatePDW() {
        setDownloadUrl("");
        var pdwUrl = `${api_base_url}delete_pdw/download/${categoryid}/${channelKey}`;
        let res = await ServiceWrapper.doGet(
            pdwUrl,
            null,
            null,
            AuthManager.getGmsToken()
        );
        if (!res.errorfound) {
            if (res.data.done) {
                setDownloadUrl(res.data.data);
                toast.success("Downloaded successfully");
            }
        } else {
            toast.error("Download failed");
        }
        setTimeout(() => {
            setDownloadUrl("");
        }, 2000);
    }

    const fetchTableDataAndAttributes = () => {
        fetchAttributes()
        props.fetchData()
    }

    const modalRoot = document.querySelector('#modal-root');

    return (
        <>
            <nav className={`tw-flex`} aria-label="Breadcrumb">
                <ol className={`tw-inline-flex tw-items-center tw-space-x-1 md:tw-space-x-3`}>
                    <li className={`tw-inline-flex tw-items-center`}>
                        <Link to={PRODUCT_DELTA_CATEGORY_LIST} className={`tw-text-xs tw-leading-[19.6px] hover:tw-text-gray-200 tw-font-medium tw-text-gray-200 md:tw-ml-2`}>
                            {CATEGORY_LIST}
                        </Link>
                    </li>
                    {!dataLoading && prodContext.findSelectedCategoryTypeName(prodContext.categoryData, categoryid) && <li>
                        <div className={`tw-flex tw-items-center tw-pointer-events-none`}>
                            <img alt="" src={arrowIcon} />
                            <Link to="#" className={`tw-ml-1 tw-text-xs tw-leading-[19.6px] tw-font-medium tw-text-gray-200 md:tw-ml-2`}>{!dataLoading ? prodContext.findSelectedCategoryTypeName(prodContext.categoryData, categoryid) : ""}</Link>
                        </div>
                    </li>}
                    <li>
                        <div className={`tw-flex tw-items-center tw-pointer-events-none`}>
                            <img alt="" src={arrowIcon} />
                            <Link to="#" className={`tw-ml-1 tw-text-xs tw-leading-[19.6px] tw-font-medium tw-text-gray-200 md:tw-ml-2`}>{!dataLoading ? selectedCategoryName : ""}</Link>
                        </div>
                    </li>
                </ol>
            </nav>
            <div className={`tw-flex tw-justify-between py-3`}>
                <div className={`tw-mt-3 tw-flex`}>
                    <Link to={PRODUCT_DELTA_CATEGORY_LIST} className={`tw-flex`}>
                        <img className={`tw-cursor-pointer`}
                            src={backIcon} alt="Delete Icon" />
                    </Link>
                    <div className={`tw-flex tw-flex-row tw-py-0 tw-px-2.5 tw-items-center tw-justify-center tw-gap-[10px] tw-text-5xl tw-text-gray-300`}>
                        <ProductCategoryDropDown fetchData={props.fetchData} setFilters={setFilters} />
                        <div className={`${dataLoading && "tw-animate-pulse"} tw-top-[116px] tw-left-[475px] tw-rounded-[44px] tw-bg-[#DFE1E6] tw-h-[26px] tw-flex tw-flex-row tw-py-0.5 tw-px-3 tw-box-border tw-items-center tw-justify-center tw-text-slategray-200`}>
                            <div className={`tw-text-sm tw-font-normal tw-text-[#505F79`}>{totalProducts} Products</div>
                        </div>
                    </div>
                </div>
                <div className={`tw-ps-3`}>
                    <button className={`button-style`} onClick={() => { if (createPermission) { history.push(`${PRODUCT_CREATE}?categoryid=${categoryid}`) } else { toast.info("You don't have permission to Create a Product") } }}>{CREATE_PRODUCT}</button>
                </div>
            </div>
            <div className={`tw-flex tw-py-1.5 ${selectedFilterList.current.length !== 0 ? 'tw-border-y' : 'tw-border-t'} tw-overflow-x-scroll no-scrollbar`}>
                {selectedFilterList.current.length !== 0 ? <div className={`tw-flex tw-items-center tw-whitespace-nowrap  tw-w-auto`}>
                    <label htmlFor="" className={`tw-font-semibold tw-text-xs tw-me-3 tw-text-[#6B778C]`}>Filter</label>

                    {selectedFilterList.current?.map((attribute: TAttribute) => (
                        attribute.values.map((value) => (
                            <div key={value.id} className={`tw-rounded tw-w-auto tw-bg-white tw-flex tw-justify-between tw-my-2 tw-py-1 tw-px-2 tw-me-3 tw-items-center tw-gap-[10px] tw-border-[1px] tw-border-solid tw-border-[#DFE1E6]`}>
                                <label className={`tw-text-[#505F79] tw-font-medium tw-text-xs`}>{attribute.name}: {value.value}</label>
                                <button onClick={(e) => {
                                    e.preventDefault()
                                    prodContext.selectedFilterList.current = prodContext.toggleAttributeValueInPlace(prodContext.selectedFilterList.current, attribute.id, attribute.name, value.id, value.value);
                                    handleFilterDelete(e, "filters", value.id)
                                }}><XIcon /></button>
                            </div>
                        ))
                    ))}

                </div> : null}
            </div>
            <div className={`tw-flex tw-flex-wrap tw-items-center tw-justify-end`}>
                <div className={`tw-w-min`}><CustomSearchBar handleSearchChange={handleSearchChange} placeholder="Search Products" autoComplete="off" /></div>
                <ProductSort filters={filters} setFilters={setFilters} />
                <ProductFilter
                    categoryid={categoryid}
                    handleAttributesChange={handleAttributesChange}
                    filters={filters}
                />
                <BulkAction
                    filters={filters}
                    onOpen={openDialog}
                    onOpenCreateParent={openParentModal}
                    productsSelected={productSelected}
                    childSelected={childSelected}
                    openDeleteModal={openDeleteModal}
                    onOpenCreateModal={modalCreateOpen}
                    onOpenUpdateModal={modalUpdateOpen}
                    onOpenValidateModal={modalValidateOpen}
                    onOpenRecategorizeModal={modalRecategorizeOpen}
                    onOpenLogsModal={modalLogsOpen}
                    onOpenTemplateModal={modalTemplateOpen}
                    downloadTemplate={generatePDW}
                    openBulkDeleteXLSModal={openBulkDeleteXLSModal}
                />

            </div>
            {
                (moveToParentModal && modalRoot) &&
                ReactDOM.createPortal(<MoveToParentDialog
                    categoryid={categoryid}
                    onClose={closeDialog}
                    search={search}
                    setSearch={setSearch}
                    handleSubmit={handleMovetoParent}
                    loading={formLoading}
                    setParentId={setParentId}
                />,
                    modalRoot)
            }


            <BulkDeleteXLSModal
                isOpen={bulkDeleteXLSModal}
                onClose={() => setBulkDeleteXLSModal(false)}
                fetchData={props.fetchData}
            />

            <CreateEditParentDialog
                heading="Create Parent"
                onClose={closeParentModal}
                handleSubmit={handleCreateParent}
                isOpen={createParentModal}
                buttonLabel="Create"
            />
            {/* {@todo remove} */}
            {/* {
                (createParentModal && modalRoot) && 
                    ReactDOM.createPortal(, 
                    modalRoot)
            } */}

            {
                (showCreatePopup && modalRoot) &&
                ReactDOM.createPortal(<CreatePDW
                    fetchData={fetchTableDataAndAttributes}
                    showCreatePopup={showCreatePopup}
                    modalCreateClose={modalCreateClose}
                />,
                    modalRoot
                )
            }

            {
                (showUpdatePopup && modalRoot) &&
                ReactDOM.createPortal(<UpdatePDW
                    fetchData={fetchTableDataAndAttributes}
                    showUpdatePopup={showUpdatePopup}
                    modalUpdateClose={modalUpdateClose}
                />,
                    modalRoot
                )
            }

            {
                (showValidatePopup && modalRoot) &&
                ReactDOM.createPortal(<ValidatePDW
                    showValidatePopup={showValidatePopup}
                    modalValidateClose={modalValidateClose}
                />,
                    modalRoot
                )
            }
            {
                (showRecategorizePopup && modalRoot) &&
                ReactDOM.createPortal(<RecategorizeModal
                    showRecategorizePopup={showRecategorizePopup}
                    modalRecategorizeClose={modalRecategorizeClose}
                    selectedProducts={selectedProducts}
                    setSelectedProducts={setSelectedProducts}
                />,
                    modalRoot
                )
            }

            {
                (showLogs && modalRoot) &&
                ReactDOM.createPortal(<LogsPDW
                    showLogs={showLogs} modalLogsClose={modalLogsClose}
                />,
                    modalRoot
                )
            }

            {
                (showTemplate && modalRoot) &&
                ReactDOM.createPortal(<TemplatePDW
                    showPopup={showTemplate}
                    modalClose={modalTemplateClose}
                    categoriesList={categoriesList}
                    categoryTypeList={categoryTypeList}
                />,
                    modalRoot
                )
            }
            <ProductDeleteConfirmationModal
                showModal={deleteModal && (childSelected && productSelected) && modalRoot}
                closeModal={closeDeleteModal}
                loading={deleteLoading}
                totalProducts={childSelected?.length + productSelected?.length}
                onConfirm={handleDelete}
            />

            <RemoveChildModal
                isOpen={prodContext.removeChildModal}
                onClose={() => prodContext.setRemoveChildModal(false)}
                childSelected={childSelected}
                setChildSelected={setChildSelected}
                fetchData={fetchData}
            />

            <DeleteParentModal
                isOpen={!!prodContext.deleteParent}
                onClose={() => prodContext.setDeleteParent(null)}
                fetchData={fetchData}
            />

            <iframe
                style={{ display: "none" }}
                src={downloadUrl}
                onLoad={() => console.log("onLoad")}
                id="iframe_pdw_upload"
                title="Delete PDW"
            />

        </>
    );
}

export default ProductDeltaHeader